import api from '../../../api/clinique/_assurances'

const state = () => ({
    
})

// getters
const getters = {

}

// mutations
const mutations = {
    
}

// actions
const actions = {
    addAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.addAssurance(data).then(
                response => {
                    dispatch('getAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}